import React from 'react';
import { Button } from '../../components/ui/Button';
export function AboutContentSection() {
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-226">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-12 space-y-6" data-id="element-227">
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-228">
          At Peak Machine Sales, we take immense pride in representing some of
          the most impressive CNC machine tool lines in the industry. But, we're
          not just about selling machines. We're about understanding the unique
          needs and challenges of each of our customers. We tailor our offerings
          to fit like a glove, ensuring you get the most out of the solutions we
          have to offer.
        </p>

        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-229">
          Established in 1995, Peak Machine Sales stands as Michigan's foremost
          provider of CNC machine tool sales and service. Our expertise spans
          across High-Speed 3 &amp; 5 Axis Milling, Conventional Milling &amp;
          Turning, Wire and Sinker EDM, Laser Texturing/Ablation, Laser Cutting,
          Additive Manufacturing (3D Printing), Tooling, and Automation.
          Renowned for our commitment to quality customer support, we've
          assembled a team of highly skilled professionals dedicated to serving
          the Die Mold and precision part production industries. With
          strategically located offices in Wixom and Kalamazoo, Peak ensures
          comprehensive support for our product lines across the entire State of
          Michigan. Our deliberate selection of cutting-edge brands reflects our
          commitment to pioneering machining technology and manufacturing
          trends. Backed by factory-trained Peak Service Engineers, we ensure
          seamless service, directly supported by the OEMs we represent. This
          privileged access to internal databases empowers us to deliver
          factory-level service promptly and efficiently.
        </p>

        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-230">
          If you're curious to see how our CNC machine tools can work wonders
          for your business, please don't hesitate to drop us a line, shoot us a
          message, or give us a ring. We're always up for a chat, and we'd love
          to hear your goals and explore how our team can help you reach them.
          Thanks for considering Peak Machine Sales as your trusted source for
          precision CNC machines in Michigan. We look forward to building a
          fantastic partnership.
        </p>

        <div className="pt-6 flex flex-col sm:flex-row gap-4" data-id="element-231">
          <Button variant="primary" href="5.html" size="lg" data-id="element-232">
            Contact Us
          </Button>
          <Button variant="secondary" href="./" size="lg" data-id="element-233">
            View Our Product Lines
          </Button>
        </div>
      </div>
    </div>;
}